import React, { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form';
import { ToastError, ToastSuccess } from 'src/components/uiElements/toast';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  VerifyOTP as Verify_OTP,
} from "src/components/api/user/user";

type PersonalDetailProps = {  
  FirstName: string;
  LastName: string;
  FirmName: string;
  MobileNumber: string;
  EmailID: string;
  OTP?: string | null;
};


const UseVerifyOtp = (mobileNumber: string = "", signupData: PersonalDetailProps | null = null, onSuccess?: () => void) => {
  const [isSignInOpen, setIsSignInOpen] = useState(false);
  const [isSignUpOpen, setIsSignUpOpen] = useState(true);
  const [isRegiSuccess, setIsRegiSuccess] = useState(false);
  const [IsSignUp, setIsSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isVerifyOtpOpen, setIsVerifyOtpOpen] = useState(false);
  const [isOtpScreenOpen, setIsOtpScreenOpen] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const validationSchema = Yup.object().shape({
      OTP: Yup.string().nullable(),     // OTP is now optional
  });

  const defaultValues = signupData ? {
    ...signupData,
    OTP: "",
  } : {
    MobileNumber: mobileNumber,
    OTP: "",
  };

  const formContext = useForm<PersonalDetailProps>({
    defaultValues,
    resolver: yupResolver(validationSchema) as any, // Explicitly cast to any
  });

  const onSubmit: SubmitHandler<PersonalDetailProps> = async (values) => {
    let inputObj = {
      ...values,
    };
    const request = JSON.stringify(inputObj);
    setLoading(true);

    if (isUpdate === false) {      
      const response = await Verify_OTP(request);
      setLoading(false);

      if (!response?.status) {
        let failResult;
        try {
          failResult = JSON.parse(response?.data!);
        } catch (e) {
          failResult = { Message: response?.data };
        }
        ToastError(failResult.Message);
        return;
      }
      let result;
      try {
        result = JSON.parse(response?.data!);
      } catch (e) {
        result = { Message: response?.data };
      }
      ToastSuccess(result.Message);
      setIsSignUpOpen(false);
      setDeleteDialogOpen(false);
      setIsSignUp(false);
      setIsRegiSuccess(true);
      onSuccess?.();
    }
  };

  return {
    loading,
    onSubmit,
    formContext,
    IsSignUp,
    isOtpScreenOpen,
    setIsOtpScreenOpen,
    isUpdate,
    isSignUpOpen,
    setIsSignUpOpen,
    isRegiSuccess,
    setIsRegiSuccess,
    setIsSignUp,
    setIsSignInOpen,
    isSignInOpen,
  }
}

export default UseVerifyOtp;